/*
 Created by qing on 2020/12/29
 Des:
 */
import BaseConfig from "../BaseConfig";
import {CONFIG_TYPE__APPS, TODO_SHOW_TYPE__WIDE} from "../type";
import {iconList, arrayRandomElement} from "../../../assets/js/Untis";
import context from '../../main.js'

class AppsConfig extends BaseConfig {
  constructor() {
    super()

    this.h = 8

    this.minW = 10
    this.minH = 8

    this.pH = 8
    this.pW = 60

    this.pMinW = 10
    this.pMaxW = 60
    this.pMinH = 3
    this.pMaxH = 200

    this.selectAppIds = []
    this.showType = TODO_SHOW_TYPE__WIDE
  }

  get title() {
    return this.configName || AppsConfig._title
  }

  set title(content) {
    this.configName = content
  }

}

AppsConfig._title = '常用应用'
AppsConfig.type = CONFIG_TYPE__APPS

AppsConfig.prototype.configType = AppsConfig.type
AppsConfig.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    selectAppIds: this.selectAppIds,
    showType: this.showType
  }
}
AppsConfig.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.selectAppIds = opts.selectAppIds
  this.showType = opts.showType

  if (opts.hasOwnProperty('pH')) this.pH = opts.pH
  if (opts.hasOwnProperty('pW')) this.pW = opts.pW
  if (opts.hasOwnProperty('pX')) this.pX = opts.pX
  if (opts.hasOwnProperty('pY')) this.pY = opts.pY

  if (opts.showType === TODO_SHOW_TYPE__WIDE) {
    this.minW = 10
    this.minH = 7
  } else {
    this.minW = 10
    this.maxW = 20
    this.minH = 8
    this.maxH = 15
  }
}

AppsConfig.prototype.getValue = function () {

  if (!this.selectAppIds.length) {
    this.isLoad = false
    return
  }
  this.isLoad = true
  this.value = []
  context.$store.dispatch('getApps')
    .then(res => {
      if (res && res.allAppList) {
        this.selectAppIds.forEach(appId => {
          const app = res.allAppList.filter(app => app.appId === appId)[0]
          if (app) this.value.push(app)
        })
        this.handleAppInfo()
      }
      this.isLoad = false
      console.log('this.value', this.value, this.isLoad)
    }).catch(console.error)
    .finally(() => {
      this.isLoad = false
    })
}
// 兼容app没有图标
AppsConfig.prototype.handleAppInfo = function () {

  const appList = []
  this.value.forEach(item => {
    if (!item.appIcon || !item.iconColor) {
      appList.push(item)
    }
  })

  appList.forEach(item => {
    item.appIcon = arrayRandomElement(iconList())
    item.iconColor = arrayRandomElement([
      '#0E9EFF',
      '#00B0C7',
      '#B065ED',
      '#FF8249',
      '#FF627A',
      '#F5B000',
      '#7757FF',
      '#92C534',
      '#9192AB',
    ])

    context.$store.dispatch("updateApp", {
      appId: item.appId,
      appName: item.appName,
      appDes: item.appDes,
      appImg: item.appImg,
      appIcon: item.appIcon,
      appIconType: 'SYSTEM',
      iconColor: item.iconColor
    }).catch(console.error)
  })
}

export default AppsConfig
